var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGroupsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0625 2.8125C4.76413 2.8125 4.47798 2.93103 4.267 3.142C4.05603 3.35298 3.9375 3.63913 3.9375 3.9375V5.0625H2.8125C2.51413 5.0625 2.22798 5.18103 2.017 5.392C1.80603 5.60298 1.6875 5.88913 1.6875 6.1875V14.0625C1.6875 14.3609 1.80603 14.647 2.017 14.858C2.22798 15.069 2.51413 15.1875 2.8125 15.1875H13.5625C13.8443 15.1875 14.1145 15.0756 14.3138 14.8763C14.5131 14.677 14.625 14.4068 14.625 14.125V12.9375H15.8125C15.952 12.9375 16.0902 12.91 16.2191 12.8566C16.348 12.8032 16.4651 12.725 16.5638 12.6263C16.6625 12.5276 16.7407 12.4105 16.7941 12.2816C16.8475 12.1527 16.875 12.0145 16.875 11.875V5.625C16.875 5.32663 16.7565 5.04048 16.5455 4.8295C16.3345 4.61853 16.0484 4.5 15.75 4.5L10.875 4.5L8.925 3.0375C8.73027 2.89145 8.49342 2.8125 8.25 2.8125H5.0625ZM14.625 11.8125H15.75V5.625H10.875C10.6316 5.625 10.3947 5.54605 10.2 5.4L8.25 3.9375L5.0625 3.9375V5.0625H6C6.24342 5.0625 6.48027 5.14145 6.675 5.2875L8.625 6.75H13.5C13.7984 6.75 14.0845 6.86853 14.2955 7.0795C14.5065 7.29048 14.625 7.57663 14.625 7.875V11.8125ZM2.8125 6.1875L2.8125 14.0625H13.5V7.875H8.625C8.38158 7.875 8.14473 7.79605 7.95 7.65L6 6.1875H2.8125Z",
    fill: "#22264C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGroupsBlack);
export default __webpack_public_path__ + "static/media/ic_groups_black.094ca232.svg";
export { ForwardRef as ReactComponent };